// extracted by mini-css-extract-plugin
export default {"result":"D1JeTK30L8ycOeSozEpQ","actions":"EIz0uGejmraG7bX3cDtM"};